import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PonchoUIModule } from '@poncho/ui';

@Component({
    selector: 'app-feedback-review-dialog',
    templateUrl: './feedback-review-dialog.component.html',
    styleUrls: ['./feedback-review-dialog.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, PonchoUIModule]
})

export class FeedbackReviewDialogComponent {

    feedbackReview: FormGroup;
    placeholder = "Please specify in detail";

    constructor(
        private dialogRef: MatDialogRef<FeedbackReviewDialogComponent>,
        private fb: FormBuilder
    ) { 
        this.feedbackReview = this.fb.group({
            reviewTextArea: ""
        })
    }

    submitFeedback() {
        this.dialogRef.close(this.feedbackReview.get('reviewTextArea').value);
    }
}